import { Component, Injector, Input, OnInit } from '@angular/core';
import { ConcilioComponent } from '@conciliome/concilio-core';

@Component({
  selector: 'b2b-ui-section-discover',
  templateUrl: './b2b-ui-section-discover.component.html',
  styleUrls: ['./b2b-ui-section-discover.component.scss'],
})
export class B2bUiSectionDiscoverComponent extends ConcilioComponent implements OnInit {
  @Input() text: string;
  @Input() linkText: string;
  @Input() linkUrl: string;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
